<template>
  <div class="page flex-col">
    <div class="image-wrapper_3 flex-row justify-between">
	  <a href="https://h5.zbzt360.cn/lanhu_nengyuangu">
      <img
        class="image_4"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng29e2bca445784b8d3e5586b7c03a68e7ebb8316e3c64559dfa2acf254d1fe3cc.png"
      />
	  </a>
	  <a href="https://h5.zbzt360.cn/lanhu_shengminggu">
      <img
        class="image_5"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng198db0a4180b206a6182375da265e1271ddd4daea7273abce435f630eae91be8.png"
      />
	  </a>
    </div>
    <div class="box_1 flex-row justify-between">
      <div class="image-text_9 flex-row justify-between">
        <span class="text-group_1">能源谷</span>
        <img
          class="thumbnail_3"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng3cbc0303523b644ed0276a970f6aa12da654786526b97a682e26026b4aa31e63.png"
        />
      </div>
      <div class="image-text_10 flex-row justify-between">
        <span class="text-group_2">生命谷</span>
        <img
          class="thumbnail_4"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng3cbc0303523b644ed0276a970f6aa12da654786526b97a682e26026b4aa31e63.png"
        />
      </div>
    </div>
    <div class="image-wrapper_4 flex-row justify-between">
	  <a href="https://h5.zbzt360.cn/lanhu_shahegaojiaoyuan">
      <img
        class="image_6"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng32bccd98d48e88de7ccaf8b92dafdb65eee7896c2f624f1e881a20ef825b7aa0.png"
      />
	  </a>
	  <a href="https://h5.zbzt360.cn/lanhu_changpingxinchengdongqu">
      <img
        class="image_7"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng4863049fe87fc4b0c7a5ac123647f3bde456bc6fad812f739aba05636001c731.png"
      />
	  </a>
    </div>
    <div class="box_2 flex-row justify-between">
      <div class="image-text_11 flex-row justify-between">
        <span class="text-group_3">沙河高教园</span>
        <img
          class="thumbnail_5"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng3cbc0303523b644ed0276a970f6aa12da654786526b97a682e26026b4aa31e63.png"
        />
      </div>
      <div class="image-text_12 flex-row justify-between">
        <span class="text-group_4">昌平新城东区</span>
        <img
          class="thumbnail_6"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng3cbc0303523b644ed0276a970f6aa12da654786526b97a682e26026b4aa31e63.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />